import { computed } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";

import { INBOUND_PERMISSIONS, OUTBOUND_PERMISSIONS } from "@/constants";
import { hasAnyPermission } from "@/components/Header/utils.js";

const INBOUND = "inbound";
const OUTBOUND = "outbound";

export const useExchangeMode = () => {
  const router = useRouter();
  const route = useRoute();
  const store = useStore();

  const currentUser = computed(() => store?.getters?.getCurrentUser);
  const userIsInboundStudentManager = computed(() =>
    hasAnyPermission(currentUser.value?.permissions, INBOUND_PERMISSIONS)
  );

  const userIsOutboundStudentManager = computed(() =>
    hasAnyPermission(currentUser.value?.permissions, OUTBOUND_PERMISSIONS)
  );

  const userDefaultExchangeMode = computed(() => {
    if (userIsInboundStudentManager.value) {
      return INBOUND;
    }

    if (userIsOutboundStudentManager.value) {
      return OUTBOUND;
    }

    return undefined;
  });

  const exchangeMode = computed(() => route?.query?.exchange_mode ?? userDefaultExchangeMode.value);

  const allowedModes = computed(() => {
    const modes = [];
    if (userIsInboundStudentManager.value) modes.push(INBOUND);
    if (userIsOutboundStudentManager.value) modes.push(OUTBOUND);
    return modes;
  });

  const setExchangeMode = async (newMode, routePath) => {
    if (allowedModes.value.includes(newMode)) {
      const extraParams = ["acceptances", "approvals"].includes(route?.params?.page)
        ? { params: { ...route.params, page: routePath } }
        : undefined;
      await router.replace({
        ...route,
        ...extraParams,
        query: { ...route.query, exchange_mode: newMode ?? "" },
      });
    }
  };

  return {
    exchangeMode,
    setExchangeMode,
    userIsInboundStudentManager,
    userIsOutboundStudentManager,
  };
};
